module.exports = __webpack_public_path__ + "img/rf_advanced_2.1ae94999.jpg";